import { UnauthenticatedMainViewTypes } from "./UnauthenticatedMainViewTypes";

export const useUnauthenticatedMainViewModel = (props: UnauthenticatedMainViewTypes.Props) => {
  return {};
};
